import Common from '../Common/common';

const TicketPaidList = ({ ticket_list, ticketClick, siteId }) => {
  return (
    <div id="ticketPaidList" className="ticket-list">
      {ticket_list && ticket_list.map((ticket, index) => {
        return (
          <div key={ticket.ticket_id} className="ticket-point-box">
            <div className="frame100">
              <div className="use-point">{ticket.use_point}<span className='use-point-text'>ポイント</span></div>
            </div>
            <div className="frame42">
              <div className='frame41'>
                <div className="ticket-detail">{Common.getBrString(ticket.ticket_summary)}</div>
                <button
                  onClick={() => ticketClick(ticket.ticket_id)}
                  className="button text-black bg-lightwhite">
                  ポイントを使う
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TicketPaidList;
